import { defineComponent as _defineComponent } from 'vue'
import { now } from '@/utils/datetime';
import { reactive, onMounted, PropType, ref, onUpdated } from 'vue';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { i18n } from '@/plugins/vue-i18n';

import { NewSdsSection1Importer } from '@/lib/constructor/model/general/sds';
import { SdsSection1Importer } from '@/interfaces/model/general/sds';
import SdsSection1ImporterForm from '@/views/dashboard/sdsDrawer/forms/SdsSection1ImporterForm.vue';
import { VForm } from 'vuetify/lib/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsTableSection1Importer',
  props: {
  isEditing: {
    type: Boolean,
    default: false,
  },
  importers: {
    type: Array as PropType<Array<SdsSection1Importer>>,
    required: true,
    default: () => [],
  },
},
  emits: ["update:isValid", "update:importers"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:importers', data: Array<SdsSection1Importer>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  confirmRescue: '第1章輸入者・販売者のデータの削除フラグを外しますか',
  addImporterTitle: '第1章輸入者・販売者のデータを追加してください',
});



const headerSection1 = [
  { text: $t(sharedMessages.name), value: 'name', sortable: false },
  { text: $t(sharedMessages.address), value: 'address', sortable: false },
  {
    text: $t(sharedMessages.section1Department),
    value: 'department',
    sortable: false,
  },
  {
    text: $t(sharedMessages.contactPhoneNumber),
    value: 'phone',
    sortable: false,
  },
  { text: $t(sharedMessages.email), value: 'email', sortable: false },
  { text: '', value: 'action', sortable: false },
];

const form = ref<InstanceType<typeof VForm> | null>(null);
const importerIndex = ref<number>(0);
const isValidAddImporter = ref<boolean>(false);
const isValidEditImporter = ref<boolean>(false);
const modalAddImporter = ref<boolean>(false);
const modalEditImporter = ref<boolean>(false);
const modalDeleteImporter = ref<boolean>(false);
const modalRescueImporter = ref<boolean>(false);

const newImporter = reactive<SdsSection1Importer>(
  structuredClone(NewSdsSection1Importer)
);
const updatedImporter = reactive<SdsSection1Importer>(
  structuredClone(NewSdsSection1Importer)
);



const bindImporter = (index: number): void => {
  updatedImporter.id = props.importers[index].id;
  updatedImporter.sds_id = props.importers[index].sds_id;
  updatedImporter.sds_product_id = props.importers[index].sds_product_id;
  updatedImporter.name = props.importers[index].name;
  updatedImporter.address = props.importers[index].address;
  updatedImporter.department = props.importers[index].department;
  updatedImporter.phone = props.importers[index].phone;
  updatedImporter.email = props.importers[index].email;
  updatedImporter.created_at = props.importers[index].created_at;
  updatedImporter.updated_at = props.importers[index].updated_at;
  updatedImporter.deleted_at = props.importers[index].deleted_at;
};

const openAddImporterModal = (): void => {
  modalAddImporter.value = true;
};

const openDeleteImporterModal = (): void => {
  modalDeleteImporter.value = true;
};

const openRescueImporterModal = (): void => {
  modalRescueImporter.value = true;
};

const openEditImporterModal = (): void => {
  modalEditImporter.value = true;
};

const closeAddImporterModal = (): void => {
  modalAddImporter.value = false;
};

const closeEditImporterModal = (): void => {
  modalEditImporter.value = false;
};

const closeDeleteImporterModal = (): void => {
  modalDeleteImporter.value = false;
};

const closeRescueImporterModal = (): void => {
  modalRescueImporter.value = false;
};

const addImporter = (): void => {
  const data = structuredClone(props.importers);
  data.push(structuredClone(newImporter));

  emits('update:importers', data);
};

const clearNewSection1Importer = () => {
  newImporter.name = '';
  newImporter.address = '';
  newImporter.department = '';
  newImporter.phone = '';
  newImporter.email = '';
  newImporter.deleted_at = null;
};

const editImporter = () => {
  const data = structuredClone(props.importers);
  data[importerIndex.value].name = updatedImporter.name;
  data[importerIndex.value].address = updatedImporter.address;
  data[importerIndex.value].department = updatedImporter.department;
  data[importerIndex.value].phone = updatedImporter.phone;
  data[importerIndex.value].email = updatedImporter.email;
  data[importerIndex.value].deleted_at = updatedImporter.deleted_at;

  emits('update:importers', data);
};

const deleteImporterData = (): void => {
  const data = structuredClone(props.importers);
  data[importerIndex.value].deleted_at = now().toString();

  emits('update:importers', data);
};

const rescueImporterData = (): void => {
  const data = structuredClone(props.importers);
  data[importerIndex.value].deleted_at = null;

  emits('update:importers', data);
};

onMounted((): void => {
  if (form.value) {
    form.value.validate();
  }
});

onUpdated((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,$t, m, props, headerSection1, form, importerIndex, isValidAddImporter, isValidEditImporter, modalAddImporter, modalEditImporter, modalDeleteImporter, modalRescueImporter, newImporter, updatedImporter, emits, bindImporter, openAddImporterModal, openDeleteImporterModal, openRescueImporterModal, openEditImporterModal, closeAddImporterModal, closeEditImporterModal, closeDeleteImporterModal, closeRescueImporterModal, addImporter, clearNewSection1Importer, editImporter, deleteImporterData, rescueImporterData, sharedMessages, SdsSection1ImporterForm }
}

})